import { config } from '@/config';

// Course language tags remain regional; routes and UI resources use platform languages.
export function platformLanguage(lang?: string | null): string {
  const base = String(lang || '')
    .trim()
    .toLowerCase()
    .split(/[-_]/)[0];
  return config.langs.includes(base) ? base : 'en';
}
